export default __webpack_public_path__ + "static/B0062-f55c2a61435ffd1ca528fa2aeeada1a1.png";